import { getUserDeviceTokenKey } from '.';

export const deleteUserDeviceToken = (value: string) => {
  const key = getUserDeviceTokenKey(value);
  localStorage.removeItem(key);
};
